// src/hooks/tokenRefresh.service.ts
import axios, { AxiosResponse } from 'axios';
import { useCallback }          from 'react';
import { endpoints }            from '../constants/endpoints';
import useAuth                  from './auth.service';


export interface RefreshResponse {
  accessToken: string;
  user: unknown;
}


export default function useTokenRefresh() {
  const { logoutUser } = useAuth();

  const refreshAccessToken = useCallback(async (): Promise<
    AxiosResponse<RefreshResponse>
  > => {
    try {
      return await axios.post(endpoints.refresh, undefined, {
        withCredentials: true,      // ← sends the refreshToken cookie
      });
    } catch (err) {
      logoutUser();                 // logout only when refresh truly fails
      throw err;
    }
  }, [logoutUser]);

  return { refreshAccessToken };
}
